const channels = require.context('.', true, /_channel\.ts$/)
channels.keys().forEach(channels)
